import React from 'react';

import {
  faBalanceScale,
  faBriefcase,
  faBullhorn,
  faCalculator,
  faChartNetwork,
  faCoins,
  faFileSignature,
  faHandshake,
  faHomeHeart,
  faHouse,
  faListAlt,
  faNetworkWired,
  faNewspaper,
  faSchool,
  faThList,
  faTools,
  faTrophy,
  faUserPlus,
  faUsers,
  faSignature,
  faComputer,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import { Badge } from 'reactstrap';

import logoZelok from './assets/img/brand/logo-zelok.svg';
import faqDRC from './assets/json/faq_drc.json';
import { themeColors } from './muiTheme';
import authService from './services/Auth';
import i9nav from './views/I9/navbar';
const launchDashboard = () => {
  return getDashboardLink();
};

const getStaffDashboardLink = () => {
  return '/dashboard/staff';
};

const getDashboardLink = () => {
  let dashboardLink;

  const userCompany = authService.findUserCompany();

  if (!userCompany) {
    return '/dashboard/default';
  }
  const userContact = authService.getContact();

  switch (userCompany.code) {
    case 'CAPIFRANCE':
    case 'IMMOBILIER_NEUF':
      dashboardLink = '/dashboard/capifrance';
      break;
    case 'REFLEXIMMO':
      dashboardLink = '/dashboard/refleximmo';
      break;
    case 'OPTIMHOME':
      if (userContact && userContact.isCandidate) {
        dashboardLink = '/candidate';
      } else {
        dashboardLink = '/dashboard/optimhome';
      }
      break;
    default:
      dashboardLink = '/dashboard/default';
  }

  return dashboardLink;
};

const getNavbar = navConfig => {
  const currentContact = authService.getContact();
  const currentContactInfos = authService.getContactInfo();
  const userCompany = authService.findUserCompany();
  const lifeSpeciality = currentContactInfos.organizationSpecialities?.find(
    org => org.refOrganizationSpeciality.code === 'VIAGER',
  );
  const hasLife = typeof lifeSpeciality === 'object' || authService.getContact().isStaff;

  const navbarConfig = {
    items: [],
  };

  navbarConfig.items.push({
    name: (
      <>
        <span className={'nav-icon nav-icon-custom'}>
          <DashboardOutlinedIcon />
        </span>
        Accueil
      </>
    ),
    url: getDashboardLink(),
  });

  if (navConfig && navConfig[userCompany?.code] && navConfig[userCompany?.code].new_site_visible) {
    navbarConfig.items.push({
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <FontAwesomeIcon icon={faComputer} />
          </span>
          Mon Site Internet
          <Badge style={{ backgroundColor: themeColors[userCompany.code.toLowerCase()].MAIN }}>New!</Badge>
        </>
      ),
      class: 'nav-link-external',
      attributes: {
        target: authService.getContact().isStaff ? '' : '_blank',
        onClick: e => {
          e.preventDefault();
          navConfig.trackEvent({
            category: `New website link`,
            action: `new-website-click`,
            href: 'https://site.digitregroup.io/saml2/ff8e712c-f165-45c3-9acb-45971314d10d/login',
          });

          if (!authService.getContact().isStaff) {
            window.open('https://site.digitregroup.io/saml2/ff8e712c-f165-45c3-9acb-45971314d10d/login', '_blank');
          }

          return false;
        },
      },
    });
  }
  if (userCompany) {
    switch (userCompany.code) {
      case 'CAPIFRANCE':
        navbarConfig.items.push({
          name: (
            <>
              <span className={'nav-icon nav-icon-custom'}>
                <img src={logoZelok} height={15} width={15} alt={'logo zelok'} />
              </span>
              Zelok
            </>
          ),
          url: 'https://app.zelok.fr/sso/digitre/login',
          class: 'nav-link-external',
          attributes: {
            target: '_blank',
          },
        });

        if (authService.getContact() && authService.getContact().isStaff) {
          if (authService.can('access', 'users')) {
            navbarConfig.items.push({
              name: (
                <>
                  <span className={'nav-icon nav-icon-custom'}>
                    <FontAwesomeIcon icon={faCoins} />
                  </span>
                  Suivi ecoin
                </>
              ),
              url: '/agent',
            });
          }
        }

        if (hasLife) {
          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faHouse} />
                </span>
                Viager
              </>
            ),
            url: '/viager',
          });
        }

        break;
      case 'REFLEXIMMO':
        if (authService.can('access', 'cms')) {
          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faTools} />
                </span>
                Outils interne
              </>
            ),
            url: '/cms/hub/116',
          });

          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faBalanceScale} />
                </span>
                Juridique
              </>
            ),
            url: '/cms/hub/6',
          });

          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faFileSignature} />
                </span>
                ADV
              </>
            ),
            url: '/cms/hub/5',
          });

          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faUsers} />
                </span>
                Vie du conseiller
              </>
            ),
            url: '/cms/hub/7',
          });

          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faBriefcase} />
                </span>
                Recrutement
              </>
            ),
            url: '/cms/hub/9',
          });

          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faBullhorn} />
                </span>
                Marketing
              </>
            ),
            url: '/cms/hub/8',
          });

          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faChartNetwork} />
                </span>
                Filières
              </>
            ),
            url: '/cms/hub/10',
          });

          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faHandshake} />
                </span>
                Partenaires
              </>
            ),
            url: '/cms/hub/11',
          });

          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faNewspaper} />
                </span>
                Actualités réseau
              </>
            ),
            url: '/cms/hub/426',
          });

          if (hasLife) {
            navbarConfig.items.push({
              name: (
                <>
                  <span className={'nav-icon nav-icon-custom'}>
                    <FontAwesomeIcon icon={faHouse} />
                  </span>
                  Viager
                </>
              ),
              url: '/viager',
            });
          }
        }

        break;
      case 'OPTIMHOME':
        if (authService.can('access', 'cms') && !authService.can('admin', 'cms')) {
          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faHandshake} />
                </span>
                Apporteur d'affaires
              </>
            ),
            url: '/intermediary-business',
          });
        }

        if (currentContactInfos.iris.length > 0) {
          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faTrophy} color={themeColors.optimhome.OPTIMUST} />
                </span>
                <span style={{ color: themeColors.optimhome.OPTIMUST }}> Club Optimust </span>
              </>
            ),
            url: '/dashboard/optimust',
          });
        }

        navbarConfig.items.push({
          name: (
            <>
              <span className={'nav-icon nav-icon-custom'}>
                <FontAwesomeIcon icon={faCalculator} />
              </span>
              Estimation
            </>
          ),
          children: [
            {
              name: <>Créer une estimation</>,
              url: '/valorize/new',
            },
            {
              name: <>Liste des estimations</>,
              url: '/valorize',
            },
          ],
        });

        if (hasLife) {
          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faHouse} />
                </span>
                Viager
              </>
            ),
            url: '/viager',
          });
        }

        break;
      case 'DIGITREGROUP':
        if (authService.can('access', 'cms') && !authService.can('admin', 'cms')) {
          if (authService.getContact() && authService.getContact().isStaff) {
            navbarConfig.items.push({
              name: (
                <>
                  <span className={'nav-icon nav-icon-custom'}>
                    <FontAwesomeIcon icon={faNewspaper} />
                  </span>
                  FAQ DigitRE
                </>
              ),
              url: '/cms/hub/1',
            });
          }
        }

        break;
      case 'IMMOBILIER_NEUF':
        if (hasLife) {
          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faHouse} />
                </span>
                Viager
              </>
            ),
            url: '/viager',
          });
        }
        break;
      default:
        break;
    }
  }

  // Config process to CMS items links for staff only
  if (currentContact && currentContact.isStaff) {
    if (authService.can('admin', 'cms')) {
      navbarConfig.items.push({
        name: (
          <>
            <span className={'nav-icon nav-icon-custom'}>
              <FontAwesomeIcon icon={faNewspaper} />
            </span>
            FAQ Groupe
          </>
        ),
        url: '/cms/hub/2',
      });

      navbarConfig.items.push({
        name: (
          <>
            <span className={'nav-icon nav-icon-custom'}>
              <FontAwesomeIcon icon={faNewspaper} />
            </span>
            Backup Capifrance
          </>
        ),
        url: '/cms/hub/3',
      });

      navbarConfig.items.push({
        name: (
          <>
            <span className={'nav-icon nav-icon-custom'}>
              <FontAwesomeIcon icon={faNewspaper} />
            </span>
            Backup Optimhome
          </>
        ),
        url: '/cms/hub/4',
      });
    } else if (!authService.can('admin', 'cms')) {
      // Filter FAQ name by mail address to avoid companyId update when agent move from BU to another
      if (
        currentContact.email?.includes('@digitregroup.com') ||
        currentContact.email?.includes('@immobilier-neuf.com')
      ) {
        if (userCompany?.code !== 'DIGITREGROUP') {
          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faNewspaper} />
                </span>
                {userCompany?.code === 'OPTIMHOME' ? 'FAQ Optimhome' : 'FAQ Capifrance'}
              </>
            ),
            url: '/cms/hub/2',
          });
        } else {
          navbarConfig.items.push({
            name: (
              <>
                <span className={'nav-icon nav-icon-custom'}>
                  <FontAwesomeIcon icon={faNewspaper} />
                </span>
                FAQ Groupe
              </>
            ),
            url: '/cms/hub/2',
          });
        }
      }
      if (currentContact.email?.includes('@capifrance.fr')) {
        navbarConfig.items.push({
          name: (
            <>
              <span className={'nav-icon nav-icon-custom'}>
                <FontAwesomeIcon icon={faNewspaper} />
              </span>
              FAQ Capifrance
            </>
          ),
          url: '/cms/hub/2',
        });
      }

      if (currentContact.email?.includes('@optimhome.com')) {
        navbarConfig.items.push({
          name: (
            <>
              <span className={'nav-icon nav-icon-custom'}>
                <FontAwesomeIcon icon={faNewspaper} />
              </span>
              FAQ Optimhome
            </>
          ),
          url: '/cms/hub/2',
        });
      }
    }
  }

  // Hide sponsorship for Capifrance as it can be access by the link in a cms article
  if (userCompany?.code !== 'CAPIFRANCE' || currentContact.email?.includes('@digitregroup.com')) {
    navbarConfig.items.push({
      name: userCompany?.code === 'OPTIMHOME' ? 'Cooptation' : 'Facturation parrainage',
      icon: 'icon-share',
      url: '/sponsorship',
    });
    navbarConfig.items.push({
      name: 'MLM',
      icon: 'icon-share',
      url: '/mlm',
    });
  }

  if (authService.can('access', 'trackingurl')) {
    navbarConfig.items.push({
      name: 'URL de tracking',
      icon: 'icon-target',
      url: '/marketing-tools/url-tracking-generator',
    });
  }

  if (authService.can('list', 'dili')) {
    navbarConfig.items.push({
      name: 'Opportunités Dili',
      icon: 'icon-user-following',
      url: '/dili',
    });
  }

  if (authService.can('admin', 'drimki_leads')) {
    navbarConfig.items.push({
      name: 'Annonces ToutvaBiens',
      icon: 'fa fa-home',
      url: '/drimki/ads_requests',
    });
  }

  if (currentContact.isStaff && userCompany?.code === 'OPTIMHOME') {
    navbarConfig.items.push({
      name: 'Zone IRIS',
      icon: 'fa fa-map-marker',
      url: '/iris',
    });
  }

  if (
    authService.can('access', 'performance-plan') ||
    authService.getAccessLeader() ||
    authService.getUser().organizationRoleCode.find(orc => orc === 'DR')
  ) {
    navbarConfig.items.push({
      name: 'Plan de Performance',
      icon: 'fa fa-angle-double-up',
      url: '/plan-performance',
    });
  }

  if (authService.can('access', 'honoraires')) {
    navbarConfig.items.push({
      name: 'Honoraires Coachs',
      icon: 'cui-chevron-right',
      children: [
        {
          name: 'Honoraires Coachs',
          icon: 'fa fa-money',
          url: '/honoraires',
        },
        {
          name: 'Export Sage',
          icon: 'fa fa-plus',
          url: '/exportSage',
        },
      ],
    });
  }

  if (authService.can('access', 'objectifs_coachs')) {
    navbarConfig.items.push({
      name: 'Honoraires Admin',
      icon: 'cui-chevron-right',
      children: [
        {
          name: 'Dév. Constellation',
          icon: 'fa fa-money',
          url: '/developpement-constellation-admin',
        },
        {
          name: 'Dév. CA global',
          icon: 'fa fa-money',
          url: '/developpement-ca-global-admin',
        },
        {
          name: 'Taux de départ 1',
          icon: 'fa fa-money',
          url: '/departure-rate-1-admin',
        },
        {
          name: 'Taux de départ 2',
          icon: 'fa fa-money',
          url: '/departure-rate-2-admin',
        },
        {
          name: 'Formateur terrain',
          icon: 'fa fa-money',
          url: '/formateur-terrain-admin',
        },
      ],
    });
  }

  if (authService.can('admin', 'workshop-admin')) {
    navbarConfig.items.push({
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <FontAwesomeIcon icon={faNetworkWired} />
          </span>
          Gestion des ateliers
        </>
      ),
      url: '/workshop/builder',
    });
  }

  if (userCompany?.code === 'CAPIFRANCE' || userCompany?.code === 'DIGITREGROUP') {
    navbarConfig.items.push({
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <FontAwesomeIcon icon={faNetworkWired} />
          </span>
          Constellation
        </>
      ),
      url: '/constellation',
    });
  }

  if (authService.can('admin', 'drimki_leads')) {
    navbarConfig.items.push({
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <FontAwesomeIcon icon={faThList} />
          </span>
          Liste des leads ToutvaBiens
        </>
      ),
      url: '/list_attribution',
    });
  } else if (authService.getContact().isAgent) {
    navbarConfig.items.push({
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <FontAwesomeIcon icon={faListAlt} />
          </span>
          Mes leads ToutvaBiens
        </>
      ),
      url: '/list_attribution',
    });
  }

  if (userCompany?.code === 'CAPIFRANCE' || userCompany?.code === 'DIGITREGROUP') {
    navbarConfig.items.push({
      name: 'Challenges 2024',
      icon: 'fa fa-angle-double-up',
      url: '/challenges/capifrance/2024',
    });
  }

  if (authService.can('access', 'users')) {
    navbarConfig.items.push({
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <FontAwesomeIcon icon={faUsers} />
          </span>
          {authService.can('admin', 'users') ? 'Gestion des utilisateurs' : 'Utilisateurs'}
        </>
      ),
      url: '/users',
    });
  }

  if (authService.can('admin', 'digitreAcademie')) {
    navbarConfig.items.push({
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <FontAwesomeIcon icon={faSchool} />
          </span>
          Admin Académie
        </>
      ),
      url: '/academy/admin/dashboard',
    });
    navbarConfig.items.push({
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <FontAwesomeIcon icon={faBriefcase} />
          </span>
          DigitRe Académie
        </>
      ),
      url: '/academy/dashboard',
    });
  }

  if (authService.can('admin', 'recruitment')) {
    navbarConfig.items.push({
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <FontAwesomeIcon icon={faUserPlus} />
          </span>
          Recrutement
        </>
      ),
      url: '/recruitment/admin',
    });
  }

  if (currentContact && currentContact.isStaff) {
    navbarConfig.items.push({
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <FontAwesomeIcon icon={faSignature} />
          </span>
          Signature
        </>
      ),
      url: '/generateursignature',
    });
  }

  if (authService.can('access', 'cms') && currentContact && currentContact.isAgent) {
    faqDRC.forEach(element => {
      return navbarConfig.items.push({
        name: element.name,
        icon: element.icon,
        url: element.url,
      });
    });
  }

  return navbarConfig;
};

const getStaffNavBar = () => {
  return {
    items: [
      {
        name: (
          <>
            <span className={'nav-icon nav-icon-custom'}>
              <DashboardOutlinedIcon />
            </span>
            Accueil
          </>
        ),
        url: '/dashboard/staff',
      },
      {
        name: (
          <>
            <span className={'nav-icon nav-icon-custom'}>
              <FontAwesomeIcon icon={faHomeHeart} />
            </span>
            Accès intranet BU
          </>
        ),
        url: getDashboardLink(),
      },
      {
        name: (
          <>
            <span className={'nav-icon nav-icon-custom'}>
              <FontAwesomeIcon icon={faListAlt} />
            </span>
            Articles
          </>
        ),
        url: '/cms/hub/1',
      },
      {
        name: (
          <>
            <span className={'nav-icon nav-icon-custom'}>
              <FontAwesomeIcon icon={faUsers} />
            </span>
            Trombinoscope
          </>
        ),
        url: '/trombi',
      },
    ],
  };
};

const getI9NavBar = i9nav;

const getLocatedNavbar = (location, config) => {
  if (['/dashboard/staff', '/trombi', '/cms/hub/1'].includes(location)) return getStaffNavBar();
  if (location.includes('/i9')) return getI9NavBar();

  return getNavbar(config);
};

export { getNavbar, getStaffNavBar, getDashboardLink, launchDashboard, getStaffDashboardLink, getLocatedNavbar };
